export const getQuestionAnswer = (answer?: string): string[] | undefined => {
  if (!answer) return undefined;

  try {
    const decoded = decodeURIComponent(answer);
    const parsed: unknown = JSON.parse(decoded);

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return undefined;
    }

    const result = Object.values(parsed).flatMap((item) => {
      if (!item || typeof item !== 'object' || Array.isArray(item)) {
        return [];
      }

      return Object.values(item).filter(
        (value): value is string => typeof value === 'string',
      );
    });

    return result.length ? result : undefined;
  } catch {
    return undefined;
  }
};